import { Component, Input, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { IUser } from 'src/app/core/models/user.model';
import { AuthService } from 'src/app/core/services/auth.service';
import { ClientService } from 'src/app/core/services/client.service';

@Component({
  selector: 'app-client-admins',
  templateUrl: './client-admins.component.html',
  styleUrls: ['./client-admins.component.css']
})
export class ClientAdminsComponent implements OnInit {
  @Input() clientId: string;
  @Input() darkMode: boolean = false;

  private dialogOptions: NgbModalOptions = {
    backdropClass: 'dark-backdrop',
    centered: true,
    windowClass: 'window-modal',
  };

  currentUser: IUser;
  
  clientAdmins: any;
  toggleAddClientAdmin: boolean = false;;
  clientAdmin = {} as IUser;
  adminPage = 1;
  adminPerPage = 3;

  toggleDmsModal: boolean = false;
  modalDeleteAdmin: any;
  selectedAdmin= {} as IUser;

  constructor(
    private clientService: ClientService,
    private authService: AuthService,
    private translate: TranslateService,
    private toastr: ToastrService,
    private modalService: NgbModal,
  ) { }

  ngOnInit(): void {
    this.authService.LoggedinUser.subscribe((user) => {
      this.currentUser = user;
    });
    this.loadClientAdmins()
  }

  
  loadClientAdmins() {
    this.clientAdmin = {};
    this.clientService
      .getClientAdmins(this.clientId, this.adminPage, this.adminPerPage)
      .subscribe(
        (res) => {
          this.clientAdmins = res;
        },
        (err) => {
          console.log(err);
        }
      );
  }

  onEditAdmin(user: IUser) {
    this.clientAdmin = user;
    this.clientAdmin.isNew = false;
    this.toggleAddClientAdmin = true;
  }

  onAddAdmin() {
    this.toggleAddClientAdmin = true;
    this.clientAdmin.isNew = true;
  }

  addClientAdmin(form: NgForm) {
    if (form.form.value.email == '') {
      this.translate
        .get('customer.enterEmailError')
        .subscribe((text: string) => {
          this.toastr.error(text);
        });
      return false;
    }
    if (form.form.value.password == '') {
      this.translate
        .get('customer.enterPasswordError')
        .subscribe((text: string) => {
          this.toastr.error(text);
        });
      return false;
    }
    if (form.form.value.password != form.form.value.passwordRepeat) {
      this.translate
        .get('customer.samePasswordError')
        .subscribe((text: string) => {
          this.toastr.error(text);
        });
      return false;
    }
    if (!form.valid) {
      return;
    }

    const { fullName, email, password } = form.form.value;

    const body = {
      name: fullName,
      email,
      password,
    };

    this.clientService.createClientAdmin(this.clientId, body).subscribe(
      (res) => {
        this.clientAdmins.results.push(res);
        this.toggleAddClientAdmin = false;
        this.toastr.success('Client admin added.');
      },
      (err) => {
        this.toastr.error(err.message);
      }
    );
  }

  
  editAdmin(form: NgForm) {
    if (form.form.value.email == '') {
      this.translate
        .get('customer.enterEmailError')
        .subscribe((text: string) => {
          this.toastr.error(text);
        });
      return false;
    }
    if (!form.valid) {
      return;
    }

    const { fullName, email } = form.form.value;

    const body = {
      name: fullName,
      email,
    };

    this.clientService
      .updateClientAdmin(this.clientId, this.clientAdmin.id, body)
      .subscribe(
        (res) => {
          this.loadClientAdmins();
          this.toggleAddClientAdmin = false;
          this.toastr.success('Client admin updated.');
        },
        (err) => {}
      );
  }

  showDialogDeleteAdmin(content, user) {
    this.selectedAdmin = user;
    this.modalDeleteAdmin = this.modalService.open(content, this.dialogOptions);
  }

  deleteClientAdmin() {
    this.clientService
      .deleteClientAdmin(this.clientId, this.selectedAdmin.id)
      .subscribe(
        (response) => {
          this.translate
            .get('customer.deletedUser')
            .subscribe((text: string) => {
              this.toastr.success('Success');
            });
          this.modalDeleteAdmin.close();

          const admin = this.clientAdmins.results.find(
            (user) => user.id === this.selectedAdmin.id
          );

          if (admin !== undefined) {
            if (this.clientAdmins.results.indexOf(admin) != -1) {
              this.clientAdmins.results.splice(this.clientAdmins.results.indexOf(admin), 1);
            }

            this.selectedAdmin = null;
          }
        },
        (error) => {
          this.toastr.error(error.message);
          this.modalDeleteAdmin.close();
        }
      );
  }

  jumpToAdminPage(event) {
    this.adminPage = event;
    this.loadClientAdmins();
  }

  onOpenDMS(admin) {
    this.selectedAdmin = admin;
    this.toggleDmsModal = true;
  }
}
